<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer004">
<h2 class="fm_head" id="_idParaDest-2"><a id="_idTextAnchor001"></a><a href="#/text/9780062917492_Contents#r_idParaDest-2"><span class="right_1" epub:type="pagebreak" id="page_v" title="v"><span class="right_1" epub:type="pagebreak" id="page_vi" title="vi">Epigraph</span></span></a></h2>
<p class="epi"><i>Who can stop grief’s avalanche once it starts to roll?</i></p>
<p class="epi_attr">E<span class="make_smallcaps">URIPIDES</span>, <i>Medea</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062917492_Epigraph.vue?654b7750